import { render, staticRenderFns } from "./New.vue?vue&type=template&id=10cfbe09&scoped=true&lang=pug&"
import script from "./New.vue?vue&type=script&lang=js&"
export * from "./New.vue?vue&type=script&lang=js&"
import style0 from "./New.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./New.vue?vue&type=style&index=1&id=10cfbe09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cfbe09",
  null
  
)

export default component.exports